<template>
  <div style="height: 100%;overflow: hidden">
    <div class="nothing-data" v-if="xData.length === 0"></div>
    <div v-else :style="{height: '100%', margin: 'auto 0', zoom: 1 / this.golobleObject.zoom}" id="bar" ref="wrap"></div>
  </div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
export default {
  name: 'rightCenterAlarm',
  data () {
    return {
      chartResize: null,
      ServiceTypeCount: [],
      yData: [],
      xData: []
    }
  },
  created () {
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.chartResize.resize()
    })
  },
  destroyed () {
  },
  methods: {
    getYearAlarmData (arr) {
      this.xData = []
      this.yData = []
      if (arr === null || arr === '') {
        return
      }
      for (let i = 0; i < arr.length; i++) {
        this.xData.push(arr[i].alarmdate)
        this.yData.push(parseInt(arr[i].alarmcount))
      }
      let vm = this
      if (this.xData.length === 0) {
        return
      }
      setTimeout(() => {
        vm.getChartData()
      }, 300)
    },
    getChartData () {
      this.chartResize = this.$echarts.init(this.$refs.wrap)
      this.chartResize.setOption({
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          top: '3%',
          left: '4%',
          right: '3%',
          bottom: '4%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.xData,
            axisTick: {
              alignWithLabel: true
            },
            axisLine: {
              lineStyle: {
                color: '#7fd4ff',
                width: 1
              }
            },
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: { // X轴文字倾斜
              interval: 0,
              rotate: 20
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#7fd4ff',
                width: 1 // 这里是为了突出显示加上的
              }
            },
            name: '',
            min: 0,
            // max: 250,
            // interval: 50,
            axisLabel: {
              formatter: '{value}'
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#182f4d',
                width: 1 // 这里是为了突出显示加上的
              }
            }
          }
        ],
        series: [
          {
            name: '数量',
            type: 'bar',
            // barWidth: '60%',
            data: this.yData,
            barWidth: 20,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                    {offset: 0, color: '#0073e5'},
                    {offset: 1, color: '#00aaff'}
                  ]
                )
              }
            }
          }
        ],
        dataZoom: [
          {
            type: 'slider',
            show: true
            // start: 0,
            // end: 49,
            // textStyle: {
            //   color: '#ccd7d7'
            // }
          }
        ]
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/weiNingComponents/rightCenterAlarm.vue